import React from 'react';
import { Home, Network, BarChart3, Wrench, Settings, Menu } from 'lucide-react';
import { useTranslation } from '../i18n';

const MOBILE_TABS = [
  { id: 'home', icon: Home, labelKey: 'nav.home' },
  { id: 'visualizer', icon: Network, labelKey: 'nav.stackMap' },
  { id: 'reports', icon: BarChart3, labelKey: 'nav.reports' },
  { id: 'tools', icon: Wrench, label: 'Tools' },
  { id: 'admin', icon: Settings, label: 'Admin' },
  { id: 'more', icon: Menu, label: 'More' },
];

export default function MobileBottomNav({ activeTab, onTabChange, moreOpen, onToggleMore }) {
  const { t } = useTranslation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur border-t safe-area-bottom" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around h-14 px-1">
        {MOBILE_TABS.map(tab => {
          const Icon = tab.icon;
          const isActive = tab.id === 'more' ? moreOpen : activeTab === tab.id;
          const label = tab.label || t(tab.labelKey);
          return (
            <button
              key={tab.id}
              onClick={() => tab.id === 'more' ? onToggleMore() : onTabChange(tab.id)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${isActive ? 'text-primary' : 'text-muted-foreground'}`}
              data-testid={`mobile-tab-${tab.id}`}
            >
              <Icon className={`h-5 w-5 ${isActive ? 'text-primary' : ''}`} />
              <span className="text-[9px] mt-0.5 font-medium">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

// More menu overlay
export function MobileMoreMenu({ onTabChange, onClose, hasPermission }) {
  const { t } = useTranslation();

  const items = [
    { id: 'database', label: t('nav.techDatabase'), show: true },
    { id: 'compare-view', label: t('nav.compare'), show: true },
    { id: 'ai', label: t('nav.ai'), show: hasPermission ? hasPermission('nav.ai') : true },
    { id: 'financial', label: 'Financial', show: hasPermission ? hasPermission('nav.admin') : true },
    { id: 'tools', label: 'Tools', show: hasPermission ? hasPermission('nav.admin') : true },
    { id: 'admin', label: t('nav.admin'), show: hasPermission ? hasPermission('nav.admin') : true },
    { id: 'wizard', label: t('nav.wizard'), show: hasPermission ? hasPermission('nav.wizard') : true },
    { id: 'super-admin', label: 'Global Admin', show: hasPermission ? hasPermission('nav.admin') : true },
    { id: 'support-mobile', label: 'Support Hub', show: true },
    { id: 'mobile-status', label: 'System Status', show: true },
    { id: 'mobile-properties', label: 'My Properties', show: true },
    { id: 'mobile-support-dial', label: 'Speed Dial', show: true },
    { id: 'mobile-incident', label: 'Report Incident', show: true },
    { id: 'mobile-scorecard', label: 'Portfolio Score', show: true },
    { id: 'mobile-spend-rings', label: 'Spend Chart', show: true },
    { id: 'mobile-integ-health', label: 'Integration Health', show: true },
    { id: 'documents', label: 'Documents', show: true },
    { id: 'templates', label: 'Templates', show: true },
    { id: 'import', label: 'Bulk Import', show: true },
  ].filter(i => i.show);

  return (
    <div className="fixed inset-0 z-40" onClick={onClose}>
      <div className="absolute inset-0 bg-black/30" />
      <div className="absolute bottom-14 left-0 right-0 bg-card border-t rounded-t-2xl p-4 max-h-[60vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="w-10 h-1 rounded-full bg-muted mx-auto mb-4" />
        <div className="grid grid-cols-3 gap-2">
          {items.map(item => (
            <button
              key={item.id}
              onClick={() => { onTabChange(item.id); onClose(); }}
              className="p-3 rounded-xl border bg-card hover:bg-muted/60 text-center transition-colors"
              data-testid={`mobile-more-${item.id}`}
            >
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
